<template>
    <main class="container d-flex" id="main">
        <div class="row main-content">
            <div class="col-md-12 col-lg-10 offset-lg-1 mb-md-3">
                <h1 class="headline" v-if="meta.title">
                    {{meta.title}}
                </h1>
                <div class="intro" v-html="meta.introText" v-if="meta.introText && !codeRequestedSuccessfully"></div>
                <div class="intro" v-else v-html="meta.successText"></div>
            </div>
            <Form :codeExpected="!meta.exhausted" :meta="meta" :newsletter="meta.newsletterAvailable" @code-requested-successfully="codeRequestStatus" v-if="formVisible"/>
        </div>
    </main>
</template>

<script>
    import Form from '@/components/Form';

    export default {
        name: "Main",
        data() {
            return {
                codeRequested: false,
                codeRequestedSuccessfully: false,
            };
        },
        components: {
            Form,
        },
        methods: {
            isFocused( focus ) {
                this.mainIsActive = focus;
                this.isTouchDevice = ( 'ontouchstart' in document.documentElement );
                this.$emit( "app-is-active", this.mainIsActive || this.isTouchDevice );
            },
            codeRequestStatus( codeRequestedSuccessfully ) {
                this.codeRequestedSuccessfully = codeRequestedSuccessfully;
            },
        },
        computed: {
            formVisible() {
                //return true;
                return !this.meta.exhausted || this.meta.waitingListAvailable || this.meta.newsletterAvailable;
            }
        },
        props: {
            meta: Object
        },
    }
</script>

<style lang="scss" scoped>
    @import "../styles/variables";

    #main {
        .main-content {
            background-color: $main-background-color;
            border-radius: $main-border-radius;
            color: $main-color;
            margin-top: $main-margin;
            margin-bottom: $main-margin;
            padding-top: $main-padding;
            padding-bottom: $main-padding;
            position: relative;

            &:before {
                background-color: $main-background-color;
                bottom: 0;
                border-radius: $main-border-radius;
                content: '';
                display: block;
                left: 0;
                height: 100%;
                margin: 0;
                opacity: 0;
                position: absolute;
                right: 0;
                top: 0;
                box-shadow: 0 0 5px 0 $box-shadow-color, 0 10px 10px 0 $box-shadow-color;
                z-index: 0;
                transition: opacity 0.75s ease-in-out;
            }

            &:hover {
                &:before {
                    opacity: 0.75;
                }
            }

            /deep/ .how-to {
                display: flex;
                list-style: none;
                padding-left: 0;
                overflow-wrap: break-word;
                word-wrap: break-word;
                -webkit-hyphens: auto;
                -ms-hyphens: auto;
                hyphens: auto;

                li {
                    counter-increment: steps-counter;
                    position: relative;

                    &:before {
                        content: counter(steps-counter);
                        position: absolute;
                        top: 0;
                        border: 2px solid $main-color;
                        border-radius: 50%;
                        text-align: center;
                    }
                }
            }

            @media (max-width: 575.98px) {
                .intro {
                    overflow-wrap: break-word;
                    word-wrap: break-word;
                    -webkit-hyphens: auto;
                    -ms-hyphens: auto;
                    hyphens: auto;
                }
            }

            @media (max-width: 1199.98px) {
                /deep/ .how-to {
                    flex-direction: column;
                    padding-bottom: $main-padding;

                    li {
                        padding-left: $main-padding*2;

                        &:before {
                            font-size: 1rem;
                            left: 0;
                            top: 0;
                            transform: translateY(25%);
                            width: 1.75rem;
                        }
                    }

                    li:not(:last-child) {
                        margin-bottom: 1rem;
                    }
                }
            }

            @media(min-width: 1200px) {
                /deep/ .how-to {
                    padding-top: 0.5rem;

                    li {
                        padding-top: 4rem;
                        width: 30%;

                        &:before {
                            top: 0;
                            left: 50%;
                            font-size: 2rem;
                            transform: translateX(-50%);
                            width: 3.25rem;
                        }
                    }

                    li:not(:last-child) {
                        margin-right: 5%;
                    }
                }
            }

            /deep/ .submit-button {
                background-color: $button-primary-color;
                font-size: $body-copy-font-size;
                font-weight: $body-copy-font-weight;
                min-width: 100px;

                &:hover {
                    background-color: map_get($theme-colors, "surface-light");
                    border-color: map_get($theme-colors, "surface-light");
                    color: map_get($theme-colors, "primary");
                }
            }
        }

        @media (max-width: 480px) {
            .main-content {
                padding: 0;

                &:before {
                    opacity: 0.75;
                }
            }
        }
    }
</style>
